import script from "./PopperActionBotFlow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopperActionBotFlow.vue?vue&type=script&setup=true&lang=ts"

import "./PopperActionBotFlow.vue?vue&type=style&index=0&id=1d46564e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d46564e"]])

export default __exports__